<template>
  <div class='app-container'>

    <icare-table
      ref='table'
      searchTip='请根据设备编号进行搜索'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='get_time_standard'
      params>
      <div>
        <!--        <span class="left-table">编号：</span>-->
        <!--        <el-input v-model="id" placeholder="请输入编号" style="width: 200px;" clearable></el-input>-->
        <!--        <span class="left-table">-->
        <!--          <el-button type="primary" icon="el-icon-search" @click="find">查找</el-button>-->
        <!--        </span>-->
        <span class='left-table'>
          <el-button type='success' icon='el-icon-circle-plus' @click='showAdd'>增加</el-button>
        </span>
      </div>
    </icare-table>
    <!-- 编辑 -->
    <el-dialog :title='editTip' :visible.sync='editVisible' @closed='closeDialog'>
      <el-form ref='form' :rules='rules' :model='form'>
        <!--        <el-form-item label="代理商ID" :label-width="formLabelWidth">-->
        <!--          <el-input v-model.number="form.agency_id" disabled></el-input>-->
        <!--        </el-form-item>-->

        <el-form-item label='标准名称' :label-width='formLabelWidth' prop='time_standard_name'>
          <el-input v-model='form.time_standard_name'></el-input>
        </el-form-item>

        <el-form-item label='充电前免费时长' :label-width='formLabelWidth' prop='duration'>
          <el-input v-model.number='form.free'>
            <template slot='append'>分钟</template>
          </el-input>
        </el-form-item>

        <el-form-item label='充电-时长收费单元' :label-width='formLabelWidth' prop='duration'>
          <el-input v-model.number='form.duration'>
            <template slot='append'>分钟</template>
          </el-input>
        </el-form-item>

        <el-form-item label='充电-时长单元收费金额' :label-width='formLabelWidth' prop='price'>
          <el-input-number :precision="2" v-model='form.price'>
          </el-input-number>元
        </el-form-item>

        <el-form-item label='超时-时长收费单元' :label-width='formLabelWidth' prop='occupy_duration'>
          <el-input v-model.number='form.occupy_duration'>
            <template slot='append'>分钟</template>
          </el-input>
        </el-form-item>
        <el-form-item label='超时-时长单元收费金额' :label-width='formLabelWidth' prop='occupy_fee'>
          <el-input-number :precision="2" v-model='form.occupy_fee'>
          </el-input-number>元
        </el-form-item>
      </el-form>

      <div slot='footer' class='dialog-footer'>
        <el-button @click='closeDialog'>取 消</el-button>
        <el-button type='primary' @click='save'>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'
import { getCookie } from '@/utils/auth'

export default {
  data() {
    return {
      id: '',
      tableParams: {
        id: null
      },
      loading: false,
      titleConfig: [
        {
          field: 'id',
          title: '流水号',
          visible: false
        },
        // {
        //   field: 'agency_id',
        //   title: '代商理ID',
        //   visible: false
        // },
        {
          field: 'time_standard_name',
          title: '标准名称',
          visible: true
        },
        {
          field: 'free',
          title: '充电前免费时长',
          visible: true,
          fuc: val => {
            return (val) + ' 分钟'
          }
        },
        {
          field: 'duration',
          title: '充电-时长收费单元',
          visible: true,
          fuc: val => {
            return (val) + ' 分钟'
          }
        },
        {
          field: 'price',
          title: '充电-时长单元收费金额',
          visible: true,
          fuc: val => {
            return (val / 100).toFixed(2) + ' 元'
          }
        },
        {
          field: 'occupy_duration',
          title: '超时-时长收费单元',
          visible: true,
          fuc: val => {
            return (val) + ' 分钟'
          }
        },
        {
          field: 'occupy_fee',
          title: '超时-时长单元收费金额',
          visible: true,
          fuc: val => {
            return (val / 100).toFixed(2) + ' 元'
          }
        },

        {
          title: '操作',
          width: 80,
          align: 'right',
          option: true,
          children: [
            {
              title: '编辑',
              color: '#67C23A',
              icon: 'el-icon-edit-outline',
              fuc: this.showEdit
            },
            {
              title: '删除',
              color: '#F56C6C',
              icon: 'el-icon-delete',
              fuc: this.delete
            }
          ]
        }
      ],
      rules: {
        time_standard_name: [
          { required: true, message: '请输入收费标准名称', trigger: 'blur' },
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        duration: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        occupy_duration: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        occupy_fee: [
          { required: true, message: '必填', trigger: 'blur' }
        ]

      },

      editTip: '',
      form: {
        id: 0
      },
      //编辑框相关信息
      formLabelWidth: '230px',
      editVisible: false,
      dialogType: 0
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    this.id = this.$route.query.id
    this.tableParams.carpark_id = this.$route.query.carpark_id
  },
  methods: {
    //关闭编辑对话框
    closeDialog() {
      this.dialogType = 0
      this.editVisible = false
      this.form = {}

      this.$refs['form'].resetFields()
      this.$refs['form'].clearValidate()
    },

    //弹出编辑(新增)对话框
    showAdd() {
      this.dialogType = 1
      this.editVisible = true
      this.editTip="新增信息"

      this.form = Object.assign({
        agency_id: parseInt(getCookie('agency_id')),
        duration: 0,
        price: 0,
        occupy_duration: 0,
        occupy_fee: 0
      })
    },

    //弹出编辑(修改)对话框
    showEdit(row) {
      this.dialogType = 2
      this.editVisible = true
      this.editTip="编辑信息"
      row.price = row.price / 100
      row.occupy_fee = row.occupy_fee / 100
      row.free = row.free
      this.form = Object.assign({}, row)
    },
    //删除某条计时收费标准记录
    delete(row) {
      this.$confirm('是否要删除：' + row.time_standard_name + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'del_time_standard',
          params: str
        }).then((res) => {
          if(res.code==10004){
            this.$message.warning('删除失败,已被使用')
          }
          this.$refs.table.refresh()
        })
      }).catch(() => {

      })
    },

    //修改计时收费标准
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let func = 'create_time_standard'
          if (this.dialogType === 2) {
            func = 'set_time_standard'
          }
          let form = Object.assign({}, this.form)
          form.price = form.price * 100
          form.occupy_fee = form.occupy_fee * 100
          let str = JSON.stringify(form)
          gateway({
            func: func,
            params: str
          }).then(() => {
            this.closeDialog()
            this.$refs.table.refresh()
          })
        } else {
          return false
        }
      })

    },
    //查找按钮事件
    find() {
      this.tableParams.id = parseInt(this.id)
    }
  }
}
</script>

<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}
</style>
